import { sendWebsocketMessage } from '../../../../../App';

export function modifyOpenOrderLimitPrice(order, newLimitPrice) {
  const msg = {
    messageType: 'orderUpdate',
    orderInfo: {
      brokerage: order.brokerage,
      accountId: order.accountId,
      orderId: order.id,
      value: newLimitPrice,
      type: 'limitPrice'
    },
  };
  sendWebsocketMessage(msg);
}



